import React, { Fragment } from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { dark } from '../theme';
import { PlainLink } from './NavLink';
import { motion } from 'framer-motion';
import { Link } from '@reach/router';
import responsive from '../utils/responsive';
import Icon from './Icon';
import theme from '../theme';

const background = theme.colors.primary.alpha(0.8).toHex();

const Banner = styled.div`
  position: absolute;
  text-align: center;

  background: ${background};

  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  padding: 0.5em 2em 0 2em;
  row-gap: 0.2em;

  word-wrap: anywhere;

  width: 50%;

  left: 50%;
  transform: translateX(-50%);

  bottom: 1em;
  border-radius: 5px;

  ${responsive.sm.andSmaller`
    width: 100%;
  `}

  ${responsive.xs.andSmaller`
    font-size: 0.8em;
  `}

  > a {
    text-decoration: none;
    :hover {
      transform: translateY(-0.1em) scale(1.05);
      color: white;
      transition: 0.1s all ease;
    }
  }
`;

const Offers = styled(motion.div)`
  position: absolute;
  top: 3em;
  right: 3em;
  width: 10em;
  height: 10em;
  border-radius: 50%;
  background: ${background};
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  cursor: pointer;
  > * {
    color: white;
    text-decoration: none;
    font-size: 1.4em;
    white-space: pre-line;
    font-weight: 300;
    line-height: 1.4;
  }

  ${responsive.sm.andSmaller`
    width: 5em;
    height: 10em;
    top: 2em;
    right: 0;
    border-radius: 5px;
    
    > * {
      color: white;
      text-decoration: none;
      font-size: 1.2em;
      font-weight: 300;
      line-height: 1.2;     
      transform: rotate(-90deg);
    }
  `}

  ${responsive.xs.andSmaller`
    height: 7em;
    font-size: 0.9em;
    
  `}
`;

const Shake = styled.a`
  @keyframes shake {
    10%,
    90% {
      transform: rotate(10deg);
    }

    20%,
    80% {
      transform: rotate(0deg);
    }

    30%,
    50%,
    70% {
      transform: rotate(-10deg);
    }
  }
  :hover {
    animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
    transform: translate3d(0, 0, 0);
    backface-visibility: hidden;
    perspective: 1000px;
  }
`;

export const OffersBanner = ({ phone, email, content }) => (
  <ThemeProvider theme={dark}>
    <Fragment>
      <Banner>
        <Shake href={`tel:${phone}`}>
          <Icon m>phone</Icon>
        </Shake>
        <Shake href={`mailto:${email}`}>
          <Icon m>mail_outline</Icon>
        </Shake>
        <PlainLink href={`tel:${phone}`} className={'plain'}>
          {phone}
        </PlainLink>
        <PlainLink href={`mailto:${email}`} className={'plain'}>
          {email}
        </PlainLink>
      </Banner>
      <Offers whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.95 }}>
        <Link to={'/promotions'}>{content.general.specialOffers}</Link>
      </Offers>
    </Fragment>
  </ThemeProvider>
);

export default Banner;
